<template>
    <h5 class="intro-paragraph" v-html="$t(content)"></h5>
</template>

<script>
export default {
    name: 'IntroParagraph',
    props: {
        content: String,
    },
};
</script>

<style scoped>
.intro-paragraph {
    font-weight: bold;
    font-size: 16px;
    line-height: 140%;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 20px;
}
</style>
